import { render, staticRenderFns } from "./base-select.vue?vue&type=template&id=bed4f80e&"
import script from "./base-select.vue?vue&type=script&lang=js&"
export * from "./base-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports